import { Component, OnInit, Input } from '@angular/core';
import { Transferencias } from '../../../models/transferencias';
import { TransferenciasService } from '../../../services/transferencias.service';
import { ProductoService } from '../../../services/producto.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-transferencias-modal',
  templateUrl: './transferencias-modal.component.html',
  styleUrls: ['./transferencias-modal.component.css'],
  providers: [
    TransferenciasService,
    ProductoService

  ]
})
export class TransferenciasModalComponent implements OnInit {
	@Input() transferencia_id: String;
	public transferencia: Transferencias;
	public loading = false;
	public detalles: Array<any>;

	constructor(
		private transferenciasService: TransferenciasService,
		private productoService: ProductoService,
		public bsModalRef: BsModalRef
	){ 
		this.transferencia = new Transferencias();
		this.detalles = [];
	}

	ngOnInit() {
		this.getTransferenciaById();
		this.getDetalles();
	}

	getTransferenciaById(){
		this.loading = true;
		let qs = "?embed=bodegaS,bodegaE";
		this.transferenciasService.getById(this.transferencia_id, qs).subscribe(
			res => {
				this.loading = false;
				this.transferencia = res;
				
				// this.transferencia.detalle.forEach(item => {
				// 	let qs = "?embed=unidadmedida";
				// 	this.productoService.getById(item.producto_id, qs).subscribe(
				// 	  res=>{
				// 		item.producto = res;
				// 	  },
				// 	  err=>{
				// 		this.loading = false;
				// 	  }
				// 	)
				//   });
			},
			err => {
				this.loading = false;
			}
		);
	}


	getDetalles(){
		this.loading = true;
		let qs = "?transferencia_id="+this.transferencia_id;
		this.transferenciasService.getDetalles(qs).subscribe(
			res => {
				this.loading = false;
				this.detalles = res;
				
			},
			err => {
				this.loading = false;
			}
		);
	}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/transferencias-modal/transferencias-modal.component.ts